import "./index.css";

import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { KeywordProfilesProvider } from "./context/keyword-profiles-context";

import JobDetail from "./components/job-detail";
import { OsintDashboard } from "./components/osint-dashboard";

export function App() {
  return (
    <KeywordProfilesProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<OsintDashboard />} />
          <Route path="/job/:jobId" element={<JobDetail />} />
        </Routes>

        <Toaster
          theme={"system"}
          toastOptions={{
            style: {
              borderRadius: 0,
            },
          }}
        />
      </BrowserRouter>
    </KeywordProfilesProvider>
  );
}

export default App;
